import { normalizeCogniveId } from './optimizerIdentityHelpers';

// The checked securities are the run's universe. Current and Pos Sizing each keep
// their own checked set, which stays as the user left it across baseline switches
// and portfolio edits. A baseline without one checks exactly its members (the
// Current holdings or the saved Pos Sizing positions, marked `baselineMember` on
// each projected row): on sign-in and after "Restore included securities".

export const NO_OPTIMIZER_SELECTIONS = Object.freeze({ normal: null, 'pos-sizing': null });

// The checked set to keep for the shown baseline, or null when it is exactly the
// baseline's members.
export function includedSelection(rows) {
    if (baselineInclusionState(rows).matches) return null;
    return new Set(
        rows
            .filter((row) => row?.checkBoxEnable === true)
            .map((row) => normalizeCogniveId(row?.cognive_id))
            .filter(Boolean),
    );
}

export function baselineInclusionState(rows) {
    let memberCount = 0;
    let matches = true;
    (Array.isArray(rows) ? rows : []).forEach((row) => {
        const member = row?.baselineMember === true;
        if (member) memberCount += 1;
        if ((row?.checkBoxEnable === true) !== member) matches = false;
    });
    return { memberCount, matches };
}

export function includeBaselineMembers(rows) {
    return (Array.isArray(rows) ? rows : []).map((row) => {
        const member = row?.baselineMember === true;
        return (row?.checkBoxEnable === true) === member
            ? row
            : { ...row, checkBoxEnable: member };
    });
}

export function baselineMembersLabel(viewMode, count) {
    const noun = viewMode === 'pos-sizing' ? 'Pos Sizing position' : 'Current holding';
    return `${count} ${noun}${count === 1 ? '' : 's'}`;
}
